import { Form, Input, Button, Card, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      await api.post(`/auth/reset-password/${token}`, values);
      message.success("Password reset successful");
      navigate("/login");
    } catch (err) {
      message.error("Invalid or expired link");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
      <Card title="Reset Password" style={{ width: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="password"
            label="New Password"
            rules={[{ required: true, min: 6 }]}
          >
            <Input.Password />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Reset Password
          </Button>
        </Form>
      </Card>
    </div>
  );
}